import React from 'react'




const HeartIcon = ({ className,isBookMarked }) => {
  return (
    !isBookMarked ? <svg className={`${className}`} width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 12C19.49 10.54 21 8.79 21 6.5C21 5.04131 20.4205 3.64236 19.3891 2.61091C18.3576 1.57946 16.9587 1 15.5 1C13.74 1 12.5 1.5 11 3C9.5 1.5 8.26 1 6.5 1C5.04131 1 3.64236 1.57946 2.61091 2.61091C1.57946 3.64236 1 5.04131 1 6.5C1 8.8 2.5 10.55 4 12L11 19L18 12Z" stroke="#F8F8F8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg> : 
     <svg className={`${className}`} width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M17 11C18.49 9.54 20 7.79 20 5.5C20 4.04131 19.4205 2.64236 18.3891 1.61091C17.3576 0.579463 15.9587 0 14.5 0C12.74 0 11.5 0.5 10 2C8.5 0.5 7.26 0 5.5 0C4.04131 0 2.64236 0.579463 1.61091 1.61091C0.579463 2.64236 0 4.04131 0 5.5C0 7.8 1.5 9.55 3 11L10 18L17 11Z" fill="#F8F8F8"/>
     </svg>
     
  )
}

export default HeartIcon